import { motion } from "framer-motion";
import { useLanguage } from "@/hooks/useLanguage";
import logoOuraTrust from "@/assets/logo-ouratrust-v2.png";

// Platform logos as SVG components for crisp rendering
const GoogleLogo = () => (
  <svg viewBox="0 0 48 48" className="w-8 h-8">
    <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
    <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
    <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
    <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
  </svg>
);

const FacebookLogo = () => (
  <svg viewBox="0 0 48 48" className="w-8 h-8">
    <path fill="#1877F2" d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"/>
    <path fill="#fff" d="M34.368,25H31v13h-5V25h-3v-4h3v-2.41c0.002-3.508,1.459-5.59,5.592-5.59H35v4h-2.287C31.104,17,31,17.6,31,18.723V21h4L34.368,25z"/>
  </svg>
);

const YelpLogo = () => (
  <svg viewBox="0 0 48 48" className="w-8 h-8">
    <path fill="#D32323" d="M24,4C12.954,4,4,12.954,4,24s8.954,20,20,20s20-8.954,20-20S35.046,4,24,4z"/>
    <path fill="#fff" d="M21.2,28.9l-6.4,2.7c-0.9,0.4-1.9-0.3-1.8-1.2l0.5-7c0.1-0.7,0.7-1.2,1.4-1.2l6.9,0.1c0.9,0,1.5,1,1.1,1.8L21.2,28.9z"/>
    <path fill="#fff" d="M25.3,31.6l3.4,6.1c0.5,0.9-0.1,1.9-1.1,1.9l-6.9-0.3c-0.7,0-1.3-0.6-1.4-1.3l-0.4-7c-0.1-0.9,0.8-1.6,1.7-1.2L25.3,31.6z"/>
    <path fill="#fff" d="M28.7,27.3l6.5,2.3c0.9,0.3,1.1,1.4,0.5,2l-5,5.1c-0.5,0.5-1.3,0.5-1.8,0l-4.8-5.3c-0.6-0.7-0.2-1.8,0.7-2L28.7,27.3z"/>
    <path fill="#fff" d="M27.7,23l6.4-2.8c0.9-0.4,1.9,0.3,1.8,1.2l-0.5,7c-0.1,0.7-0.7,1.2-1.4,1.2l-6.9-0.1c-0.9,0-1.5-1-1.1-1.8L27.7,23z"/>
    <path fill="#fff" d="M23.7,12.3l-1.4,10.4c-0.1,0.9-1.3,1.3-1.9,0.6l-7.5-8.1c-0.5-0.5-0.3-1.4,0.4-1.7l8.9-2.3C23.1,10.9,23.8,11.5,23.7,12.3z"/>
  </svg>
);

const TripAdvisorLogo = () => (
  <svg viewBox="0 0 48 48" className="w-8 h-8">
    <circle fill="#34E0A1" cx="24" cy="24" r="20"/>
    <circle fill="#fff" cx="16" cy="24" r="6"/>
    <circle fill="#191919" cx="16" cy="24" r="3"/>
    <circle fill="#fff" cx="32" cy="24" r="6"/>
    <circle fill="#191919" cx="32" cy="24" r="3"/>
    <path fill="#fff" d="M24,16c-2.8,0-5.3,0.9-7.4,2.5l3.7,3.7c1-0.8,2.3-1.2,3.7-1.2s2.7,0.5,3.7,1.2l3.7-3.7C29.3,16.9,26.8,16,24,16z"/>
  </svg>
);

const TrustpilotLogo = () => (
  <svg viewBox="0 0 48 48" className="w-8 h-8">
    <path fill="#00B67A" d="M24,4l5.5,16.9H47L32.3,31.5l5.5,16.9L24,37.9l-13.8,10.5l5.5-16.9L2,20.9h17.5L24,4z"/>
  </svg>
);

export function CentralizationHub() {
  const { language } = useLanguage();

  const content = {
    fr: {
      title: "Hub de Centralisation",
      subtitle: "Pilotez votre e-réputation partout, depuis un seul endroit.",
      description: "Toutes vos plateformes d'avis convergent vers un seul tableau de bord. Lisez, répondez et analysez en un clic.",
      platforms: [
        { name: "Google", Logo: GoogleLogo },
        { name: "Facebook", Logo: FacebookLogo },
        { name: "Yelp", Logo: YelpLogo },
        { name: "TripAdvisor", Logo: TripAdvisorLogo },
        { name: "Trustpilot", Logo: TrustpilotLogo },
      ],
      dashboardLabel: "Dashboard OuraTrust",
      centralizeLabel: "Centralisation automatique",
      syncedLabel: "Synchronisé",
      totalReviewsLabel: "Avis total",
      avgRatingLabel: "Note moyenne",
      respondedLabel: "Répondu",
    },
    en: {
      title: "Centralization Hub",
      subtitle: "Manage your online reputation everywhere, from one place.",
      description: "All your review platforms converge into one dashboard. Read, respond, and analyze in one click.",
      platforms: [
        { name: "Google", Logo: GoogleLogo },
        { name: "Facebook", Logo: FacebookLogo },
        { name: "Yelp", Logo: YelpLogo },
        { name: "TripAdvisor", Logo: TripAdvisorLogo },
        { name: "Trustpilot", Logo: TrustpilotLogo },
      ],
      dashboardLabel: "OuraTrust Dashboard",
      centralizeLabel: "Automatic Sync",
      syncedLabel: "Synced",
      totalReviewsLabel: "Total reviews",
      avgRatingLabel: "Avg. rating",
      respondedLabel: "Responded",
    },
  };

  const t = content[language];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50 overflow-hidden">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            {t.title}
          </h2>
          <p className="text-xl md:text-2xl text-primary font-medium mb-3">
            {t.subtitle}
          </p>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            {t.description}
          </p>
        </motion.div>

        {/* Visual Hub */}
        <div className="relative max-w-4xl mx-auto">
          {/* Connection lines (SVG) */}
          <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{ zIndex: 0 }}>
            <defs>
              <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity="0.3" />
                <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity="0.8" />
              </linearGradient>
            </defs>
          </svg>

          {/* Platform Icons Grid */}
          <div className="grid grid-cols-5 gap-4 md:gap-8 mb-8">
            {t.platforms.map((platform, index) => (
              <motion.div
                key={platform.name}
                initial={{ opacity: 0, y: -30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className="flex flex-col items-center"
              >
                <div className="w-14 h-14 md:w-20 md:h-20 bg-white rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-100 flex items-center justify-center hover:shadow-xl hover:scale-105 transition-all duration-300">
                  <platform.Logo />
                </div>
                <span className="mt-2 text-xs md:text-sm font-medium text-muted-foreground">
                  {platform.name}
                </span>
              </motion.div>
            ))}
          </div>

          {/* Animated Arrows */}
          <div className="flex justify-center mb-8">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5 }}
              className="flex flex-col items-center gap-2"
            >
              {/* Animated flowing arrows */}
              <div className="flex gap-2 md:gap-4">
                {[...Array(5)].map((_, i) => (
                  <motion.div
                    key={i}
                    animate={{ y: [0, 8, 0] }}
                    transition={{ 
                      duration: 1.5, 
                      repeat: Infinity, 
                      delay: i * 0.15,
                      ease: "easeInOut"
                    }}
                    className="w-0.5 h-12 md:h-16 bg-gradient-to-b from-primary/30 via-primary to-primary/30 rounded-full"
                  />
                ))}
              </div>
              <motion.span
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.7 }}
                className="text-xs text-primary font-medium px-3 py-1 bg-primary/10 rounded-full"
              >
                {t.centralizeLabel}
              </motion.span>
            </motion.div>
          </div>

          {/* Central Dashboard */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.8, duration: 0.5 }}
            className="flex justify-center"
          >
            <div className="relative">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-primary/20 via-success/20 to-primary/20 blur-3xl rounded-full scale-150" />
              
              {/* Dashboard card */}
              <div className="relative bg-white rounded-3xl shadow-2xl shadow-primary/10 border border-primary/20 p-6 md:p-8">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-slate-900 to-slate-700 rounded-2xl flex items-center justify-center shadow-lg">
                    <img 
                      src={logoOuraTrust} 
                      alt="OuraTrust" 
                      className="w-12 h-12 md:w-14 md:h-14 object-contain brightness-0 invert" 
                    />
                  </div>
                  <div>
                    <h3 className="text-lg md:text-xl font-bold text-foreground">
                      {t.dashboardLabel}
                    </h3>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="w-2 h-2 bg-success rounded-full animate-pulse" />
                      <span className="text-sm text-success font-medium">
                        {t.syncedLabel}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Mini stats preview */}
                <div className="grid grid-cols-3 gap-4 mt-6">
                  <div className="bg-slate-50 rounded-xl p-3 text-center">
                    <p className="text-2xl font-bold text-foreground">247</p>
                    <p className="text-xs text-muted-foreground">{t.totalReviewsLabel}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3 text-center">
                    <p className="text-2xl font-bold text-success">4.8</p>
                    <p className="text-xs text-muted-foreground">{t.avgRatingLabel}</p>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3 text-center">
                    <p className="text-2xl font-bold text-primary">98%</p>
                    <p className="text-xs text-muted-foreground">{t.respondedLabel}</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}